module.exports = "<p>\n  product-results works!\n</p>\n"